module.exports = __webpack_public_path__ + "img/2fecb57799d2058a027e284dc7e3458f.png";